/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsSwitchCreateParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsSwitchCreateParams = zod.input<
    typeof ApiAccountsSwitchCreateParams
>;
export type ApiAccountsSwitchCreateParamsOutput = zod.output<
    typeof ApiAccountsSwitchCreateParams
>;
